import React from "react";

import { useTheme } from "@/components/theme-provider";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { cn } from "@/lib/utils";

const FieldTableHeader = React.memo((): JSX.Element => {
  const { theme: skin } = useTheme();

  const commonClasses = React.useMemo(
    () =>
      cn(
        "text-primary uppercase  ",
        skin === "dark" && "text-white",
        skin !== "dark" ? "bg-[#E4E8F2]" : "bg-primaryLight",
        "border-r border-r-white ",
      ),
    [skin],
  );

  return (
    <TableHeader
      className={cn(skin !== "dark" ? "bg-[#E4E8F2]" : "bg-primaryLight")}
    >
      <TableRow>
        <TableHead className={commonClasses} scope='col'>
          ITEM
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          DESCRIPTION
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          PRICE($)
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          Quantity
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          DISC($)
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          TRACKING NAME
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          TRACKING OPTION
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          ACCOUNT
        </TableHead>
        <TableHead className={commonClasses} scope='col'>
          TAX(%)
        </TableHead>
        <TableHead className={commonClasses + "border-0"} scope='col'>
          TOTAL($)
        </TableHead>
        <TableHead
          className={commonClasses}
          scope='col'
          aria-label='Actions'
        ></TableHead>
      </TableRow>
    </TableHeader>
  );
});

FieldTableHeader.displayName = "FieldTableHeader";

export { FieldTableHeader };
